type EnvironmentMap = Readonly<Record<string, string | undefined>>;

interface LazyString {
    [Symbol.toPrimitive](): string;
    toString(): string;
    valueOf(): string;
}

function readEnvironmentVariable(name: string): string | undefined {
    const value = (import.meta.env as EnvironmentMap)[name];

    if (typeof value === 'string' && value.length > 0) {
        return value;
    }

    return undefined;
}

export function getEnvironmentVariable(name: string): string | null {
    return readEnvironmentVariable(name) ?? null;
}

export function getRequiredEnvironmentVariable(name: string): string {
    const value = readEnvironmentVariable(name);

    if (!value) {
        throw new Error(`Missing ${name}`);
    }

    return value;
}

// Keep shared utility imports safe for apps that never execute the related feature.
function createLazyString(factory: () => string): string {
    const lazyString: LazyString = {
        [Symbol.toPrimitive]: factory,
        toString: factory,
        valueOf: factory,
    };

    return lazyString as unknown as string;
}

export function getLazyRequiredEnvironmentUrl(name: string, protocol: string): string {
    return createLazyString(() => `${protocol}://${getRequiredEnvironmentVariable(name)}`);
}
